/** Hues a tinted chip, icon square or avatar can take (the `hue-*` utilities in globals.css). */
export const HUES = ['blue', 'green', 'purple', 'orange', 'pink', 'teal', 'yellow', 'red', 'gray'] as const;
export type Hue = (typeof HUES)[number];

/** Status tones resolve to the semantic colours, so a pill and an icon agree. */
export type Tone = Hue | 'ok' | 'danger' | 'warn' | 'info' | 'ink';

const NAMED_HUES = HUES.filter((hue) => hue !== 'gray');

/** A stable hue for a name or id, so the same person or record keeps its colour everywhere. */
export function hueFor(seed: string | number | null | undefined): Hue {
  const text = String(seed ?? '');
  if (!text) return 'gray';
  let hash = 0;
  for (const character of text) hash = (hash * 31 + character.charCodeAt(0)) >>> 0;
  return NAMED_HUES[hash % NAMED_HUES.length] ?? 'gray';
}

/** The utility that sets `--h` for a tone. */
export function hueClass(tone: Tone): string {
  return `hue-${tone}`;
}
